import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/adminService';
import SubmissionsTable from '../components/admin/SubmissionsTable';
import CouponManager from '../components/admin/CouponManager';
import Analytics from '../components/admin/Analytics';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('submissions');

    const handleLogout = () => {
        logout();
        navigate('/admin/login');
    };

    return (
        <div className="bg-dark-bg min-h-screen text-white">
            {/* Header */}
            <header className="bg-dark-card border-b border-border-gray">
                <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <span className="material-symbols-outlined text-white text-3xl">admin_panel_settings</span>
                        <div>
                            <h1 className="text-white text-xl font-bold">Projekto Admin</h1>
                            <p className="text-gray-400 text-xs">Dashboard & Management</p>
                        </div>
                    </div>

                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-2 bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 text-red-400 px-4 py-2 rounded-lg transition-all"
                    >
                        <span className="material-symbols-outlined text-lg">logout</span>
                        <span className="text-sm font-semibold">Logout</span>
                    </button>
                </div>
            </header>

            {/* Tabs */}
            <div className="bg-dark-card border-b border-border-gray">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="flex gap-1">
                        <button
                            onClick={() => setActiveTab('analytics')}
                            className={`px-6 py-4 text-sm font-semibold transition-all border-b-2 ${activeTab === 'analytics'
                                ? 'text-white border-white'
                                : 'text-gray-400 border-transparent hover:text-white'
                                }`}
                        >
                            <div className="flex items-center gap-2">
                                <span className="material-symbols-outlined text-lg">analytics</span>
                                Analytics
                            </div>
                        </button>
                        <button
                            onClick={() => setActiveTab('submissions')}
                            className={`px-6 py-4 text-sm font-semibold transition-all border-b-2 ${activeTab === 'submissions'
                                ? 'text-white border-white'
                                : 'text-gray-400 border-transparent hover:text-white'
                                }`}
                        >
                            <div className="flex items-center gap-2">
                                <span className="material-symbols-outlined text-lg">description</span>
                                Submissions
                            </div>
                        </button>
                        <button
                            onClick={() => setActiveTab('coupons')}
                            className={`px-6 py-4 text-sm font-semibold transition-all border-b-2 ${activeTab === 'coupons'
                                ? 'text-white border-white'
                                : 'text-gray-400 border-transparent hover:text-white'
                                }`}
                        >
                            <div className="flex items-center gap-2">
                                <span className="material-symbols-outlined text-lg">local_offer</span>
                                Coupons
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            {/* Content */}
            <main className="max-w-7xl mx-auto px-6 py-8">
                {activeTab === 'analytics' && <Analytics />}
                {activeTab === 'submissions' && <SubmissionsTable />}
                {activeTab === 'coupons' && <CouponManager />}
            </main>
        </div>
    );
};

export default AdminDashboard;
